import styled from 'styled-components'
import { HeaderText6 } from '../HeaderText'
import { STYLES } from '../../static/style'

const FormSectionHeader = styled(HeaderText6)`
  padding-right: 0;
  width: 100%;
  margin: ${STYLES.GUTTER} 0;
`

export { FormSectionHeader }
